import expanderTemplate from './text-with-expander.pug';
import helpPopUpTemplate from './help-pop-up.pug';

export function generateConfig({
  data,
  i18n,
}) {
  const columns = [{
    name: 'Name',
    field: 'Name',
    title: i18n.get('Import_ImportSummary_Entities'),
    bodyClasses: 'truncated',
    template: expanderTemplate,
    property: entity => ({
      expandable: entity.Expandable,
      name: entity.Name,
      expanded: entity.Expanded,
      isChildren: entity.IsChildren,
    }),
  }, {
    name: 'Additions',
    title: i18n.get('Import_ImportSummary_NewImport'),
  }, {
    name: 'Changes',
    title: i18n.get('Import_ImportSummary_SyncedImport'),
  }, {
    name: 'Deletions',
    title: i18n.get('Import_ImportSummary_DeletedImport'),
  }, {
    name: 'Errors',
    html: helpPopUpTemplate({
      title: i18n.get('Import_ImportSummary_SkippedImport'),
      popupId: 'Page_Import_Summary_Skipped',
      arialLabelText: `${i18n.get('Learn_more_link_text')} ${i18n.get('Import_ImportSummary_SkippedImport')}`,
    }),
  }];

  const tableName = i18n.getString('Import_ImportSummary_Title');
  const plugins = {
    a11y: { i18n },
  };

  return {
    dataSource: {
      type: 'memory',
      data,
    },
    scrolling: {
      // in test environment, turn off virtualization.
      virtualized: (/isselenium/i).exec(window.location.search) === null,
      header: {
        type: 'fixed',
        attributes: { 'aria-label': i18n.getString('{{tableName}} table header').replace('{{tableName}}', tableName) },
      },
    },
    columns,
    tableClasses: ['table', 'table-bordered'],
    tableAttributes: { 'aria-label': tableName },
    plugins,
  };
}
